// extracted by css-extract-rspack-plugin
export default {"button":"_57cb8909"};